import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { CSSTransition, SwitchTransition } from "react-transition-group";

import { Reply } from "@/types"

import {
  repliesGet,
} from "@/store/replies";

import AppBox from "@/components/AppBox";
import AppText from "@/components/AppText";
import AppCard from "@/components/AppCard";
import AnsweredCallReplies from "./AnsweredCallReplies";
import MissedCallReplies from "./MissedCallReplies";
import MessageLeadReplies from "./MessageLeadReplies";

const configItems = [
  { label: "Message Lead", value: "autoresponder" },
  { label: "Missed Call Lead", value: "missed-call" },
  { label: "Answered Call Lead", value: "answered-call" },
];

interface RepliesProps {
  replies: Reply[];
  config: any;
  onChange: (data: any) => void;
  onConfigChange: (field: string, value: any) => void;
}

const Replies: React.FC<RepliesProps> = ({replies, config, onChange, onConfigChange}) => {
  const dispatch = useAppDispatch();

  const { me } = useAppSelector((state) => state.auth);
  const { isMobile } = useAppSelector((state) => state.app);

  const [activeItem, setActiveItem] = useState<string>(configItems[0]?.value);

  useEffect(() => {
    if (me.id) {
      dispatch(repliesGet());
    }
  }, [me]);

  const handleItemClick = (value: string) => {
    setActiveItem(value);
  }

  const getConfigComponent = () => {
    switch (activeItem) {
      case "missed-call":
        return <MissedCallReplies replies={replies} onChange={onChange} />;
      case "answered-call":
        return <AnsweredCallReplies config={config} onConfigChange={onConfigChange} />;
      default:
        return <MessageLeadReplies replies={replies} onChange={onChange} />;
    }
  };

  return (
    <AppCard className="overflow-auto pt-0 sm:pt-0">
      {/* Tabs header */}
      <AppBox
        gap={isMobile ? 4 : 8}
        className="py-2 pt-4 border-b border-b-gray-200 h-[53px] items-center md:items-start sticky top-0 bg-white z-20"
      >
        {configItems.map((item) => (
          <AppText
            key={item.value}
            variant={isMobile ? "label" : "h5"}
            weight={activeItem === item.value ? "medium" : "normal"}
            color={activeItem === item.value ? "primary" : "dark"}
            className={`cursor-pointer hover:text-primary ${activeItem === item.value ? "border-primary" : ""}`}
            onClick={() => handleItemClick(item.value)}
          >
            {item.label}
          </AppText>
        ))}
      </AppBox>

      {/* Auto Replies Section */}
      <SwitchTransition mode="out-in">
        <CSSTransition
          key={activeItem} // Ensure unique key for each tab
          classNames="replies" // Match CSS class prefix
          timeout={200} // Match animation duration in ms
        >
          {getConfigComponent()}
        </CSSTransition>
      </SwitchTransition>
    </AppCard>
  );
};

export default Replies;